import { Injectable, inject } from '@angular/core';

import { AccessRole } from '../../models/access.token.models/access.role';
import { AccessControlService } from './access-control.srvice';

@Injectable({
  providedIn: 'root',
})
export class PaAuthGuard {
  accessControl = inject(AccessControlService);

  accessRole: AccessRole = new AccessRole();

  canActivate(): boolean {
    if (this.accessControl.hasAccess(this.accessRole.USER_ROLE_PA) || this.accessControl.loginService.getUserToken().MasterEmail) {
      return true;
    } else {
      this.accessControl.handleAccessDenied();
      return false;
    }
  }
}
